import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDate',
  standalone: true
})
export class FormatDatePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (!value) {
      return '';
    }

    try {
      // Parse the date
      const date = new Date(value);

      // Check if date is valid
      if (isNaN(date.getTime())) {
        return '';
      }

      // Format options
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      };

      // Format the date
      return new Intl.DateTimeFormat('fr-FR', options).format(date);
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  }
}
